package com.milta.core.localization.translations.es

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Escanear un documento",
    reviewTitle = "Verificar los datos",
    fileSentSuffix = "enviada hace un momento",
    analysingTitle = "Leyendo el documento…",
    analysingSubtitle = "Estamos detectando las entregas en la foto. Solo toma unos segundos.",
    deliveriesDetectedSuffix = "entregas detectadas",
    toCompleteSuffix = "por completar",
    reviewHint = "Complete las entregas señaladas antes de añadirlas a la ruta",
    addressMissingWarning = "Falta la dirección",
    nameMissingWarning = "Falta el nombre",
    recipientMissingPlaceholder = "Destinatario no detectado",
    phoneNotDetectedNote = "Teléfono no detectado — no bloquea la incorporación",
    deadlineLabelPrefix = "Hora límite",
    completeLinkLabel = "Completar",
    addToRouteButtonPrefix = "Añadir a la ruta",
    correctionRecipientLabel = "Destinatario",
    correctionAddressLabel = "Dirección",
    correctionPhoneLabel = "Teléfono",
    correctionDeadlineLabel = "Hora límite",
    unreadableTitle = "Foto ilegible.",
    unreadableMessage = "No detectamos ninguna entrega en esta imagen — tome una foto bien encuadrada y bien iluminada.",
    retakePhotoButton = "Tomar otra foto",
    manualEntryButton = "Introducir manualmente",
    rateLimitTitle = "Se han realizado demasiados escaneos recientemente.",
    rateLimitMessage = "Vuelva a intentarlo más tarde, o complete esta entrega manualmente mientras tanto.",
    rateLimitRetakeUnavailableLabel = "Tomar otra foto — no disponible por ahora",
)
